import Swiper, { Navigation, Pagination, Scrollbar, Autoplay, FreeMode } from 'swiper';



function where_next() {
   
 }
 
 export default where_next;


